import React, { useState } from "react";
import { Add } from "@mui/icons-material";
import { Box, BoxProps, Button, Paper, Popover } from "@mui/material";

import { useCreatePermissionCheck } from "fond/hooks/useCreatePermissionCheck";
import { NewItemSource } from "fond/types/analytics";
import NewItemList from "fond/widgets/NewItemList";

interface RouteParams {
  folderId: string;
}

type NewItemButtonProps = {
  width?: number | string;
  sx?: BoxProps["sx"];
  children?: React.ReactNode;
  source: NewItemSource;
};

const NewItemButton: React.FC<NewItemButtonProps> = ({ width = 160, sx, children = "New", source }: NewItemButtonProps) => {
  const [popoverAnchorButton, setPopoverAnchorButton] = useState<HTMLButtonElement | null>(null);
  const { canAddFolder, canCreateProject } = useCreatePermissionCheck();
  const isPopoverOpen = !!popoverAnchorButton;

  if (!canAddFolder && !canCreateProject) {
    return null;
  }

  return (
    <Box width={width} sx={sx}>
      <Button
        data-testid="new-button"
        fullWidth
        variant="contained"
        color="primary"
        startIcon={<Add />}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          setPopoverAnchorButton(event.currentTarget);
        }}
      >
        {children}
      </Button>
      <Popover
        id={isPopoverOpen ? "new-item-popover" : undefined}
        open={isPopoverOpen}
        keepMounted
        anchorEl={popoverAnchorButton}
        onClose={() => {
          setPopoverAnchorButton(null);
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Paper data-testid="new-item-menu-popover" sx={{ width: 250, maxWidth: "100%" }}>
          <NewItemList showDividers onItemClick={() => setPopoverAnchorButton(null)} source={source} />
        </Paper>
      </Popover>
    </Box>
  );
};

export default NewItemButton;
